import axiosNextGen from '../../../config/axios-nextgen';

export const FACILITY_INTERFACE_TYPES = [
    'None',
    'Bidirectional - Orders',
    'Bidirectional - Check In',
    'Bidirectional - Orders and Check In',
    'Unidirectional Results Only'
];

/**
 * @param {string} facilityId
 * @returns {Promise<{ interfaceType: string|null, interfaceWorkflowSummary: string|null }>}
 */
export async function getFacilityInterface(facilityId) {
    const response = await axiosNextGen.get(`/api/facilities/${facilityId}/interface`);
    return response.data;
}
